import React from 'react';



class Sharebar extends React.Component {
    constructor(){
        super();

        this.state = {
            breakWidth: 840,
            shareURL: encodeURIComponent(document.querySelector("[property='og:url']").content),
            twitterDescription: encodeURIComponent(document.querySelector("[name='twitter:description']").content)
        };
        this.getWindowDim = this.getWindowDim.bind(this)
        this.fbLink = this.fbLink.bind(this)
        this.twitterLink = this.twitterLink.bind(this)
    }

    getWindowDim () {
        let width = Math.min(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
          ),
          height = Math.min (
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.documentElement.clientHeight,
            window.innerHeight
          );
        return { width: width, height: height};
      }
      
      fbLink(e) {
        e.preventDefault();
        let windowWidth = this.getWindowDim().width,
            left = ( windowWidth - 600) / 2,
            fbURL = "https://www.facebook.com/sharer/sharer.php?u=" + this.state.shareURL;
        if(windowWidth > this.state.breakWidth) {
          window.open(fbURL, 'facebook', 'width=600, height=450, top=200, left=' + left);
        } else {
          window.open(fbURL);
        }
      }

      twitterLink(e) {
        e.preventDefault();
        let windowWidth = this.getWindowDim().width,
            left = (windowWidth - 600) / 2,
            twitURL = "https://twitter.com/intent/tweet?url=" + this.state.shareURL + "&text=" + this.state.twitterDescription + "&via=NZSTUFF";
        if(windowWidth > this.state.breakWidth) {
          window.open(twitURL, 'twitter', 'width=600, height=450, top=200, left=' + left);
        } else {
          window.open(twitURL);
        }
      }
    render() {
       return (
          <div className="stuffHeader-container__sharebar">
            {/* eslint-disable-next-line */}
            <a onClick={this.fbLink} className="stuffHeader-container__sharebar--FB"></a>
            {/* eslint-disable-next-line */}
            <a onClick={this.twitterLink} className="stuffHeader-container__sharebar--TW"></a>
          </div>
       );
    }
}

export default Sharebar;